import { render, staticRenderFns } from "./Pdfpreview.vue?vue&type=template&id=554fc355&scoped=true"
import script from "./Pdfpreview.vue?vue&type=script&lang=js"
export * from "./Pdfpreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554fc355",
  null
  
)

export default component.exports